import "./bootstrap/bootstrap";

// shido plugins
import dimentions from "../../../node_modules/shido.dimentions.js/src/dimentions.js";
import proportional from "../../../node_modules/shido.proportional.js/src/proportional";
import regular from "../../../node_modules/shido.regular.js/src/regular";

// app
// require('../../../node_modules/...')
import alert from "./components/alerts";
import { navMobile, scrollBar } from "./components/nav";
import form from "./components/forms";

// Initializers
const docReady = () => {
    new dimentions().init();
    new proportional().init();
    new regular().init();
    new alert().session();
    new form().init();

    navMobile();
    scrollBar();
};

const winLoad = () => {
    // ...
};

const docReadyWinload = () => {
    // ...
};

// ---
// [IMPORTANT] Do not change or add anything!
document.addEventListener(
    "DOMContentLoaded",
    () => {
        docReady();
        docReadyWinload();
    },
    false
);
window.addEventListener(
    "load",
    () => {
        winLoad();
        docReadyWinload();
    },
    false
);
// ---
// ---
